import { render, staticRenderFns } from "./event_publish_management.vue?vue&type=template&id=1ffea4bf&scoped=true&"
import script from "./event_publish_management.vue?vue&type=script&lang=js&"
export * from "./event_publish_management.vue?vue&type=script&lang=js&"
import style0 from "./event_publish_management.vue?vue&type=style&index=0&id=1ffea4bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffea4bf",
  null
  
)

export default component.exports